import React, { Component } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { connect } from "react-redux";
import moment from "moment";
import withFetchHook from "../withFetchHook";
import {sendStaffAppMetaData} from "../staffApp/eventTriggers";

class ProbationFormModal extends Component {

  setDefaultStaffAppMetaData() {
    sendStaffAppMetaData(this.props.probationTabDefaultMetaData);
  }
  handleClose() {
    this.props.closeModal();
  }

  handleChange(name, value) {
    this.props.updateField(name, value);
  }

  updateResidentProbations(probation) {
    const { organizationName, resident } = this.props;

    return this.props.fetch(`/organizations/${organizationName}/residents/${resident.id}.json`, {
      method: "PATCH",
      data: {
        resident: {
          probations_attributes: [probation]
        }
      }
    })
  }

  deleteProbation() {
    const { probation, deleteProbation, closeModal } = this.props;

    this.setState({ loading: true });

    this.updateResidentProbations({
      id: probation.id,
      _destroy: true
    }).then(() => {
      this.setState({ loading: false });
      deleteProbation(probation);
      if (this.props.isStaffApp) alert("Probation successfully deleted.");
      this.setDefaultStaffAppMetaData();
      closeModal();
    });
  }

  saveProbation() {
    const { probation, updateProbations, closeModal } = this.props;

    this.setState({ loading: true });

    this.updateResidentProbations(probation).then((data) => {
      this.setState({ loading: false });
      updateProbations(data.probations);
      if (this.props.isStaffApp) alert("Probation changes saved.");
      this.setDefaultStaffAppMetaData();
      closeModal();
    });
  }

  saveProbationFunction = (e) => {
    this.props.dispatch(this.saveProbation())
  }

  componentDidMount() {
    document.addEventListener("saveProbation", this.saveProbationFunction);
  }

  componentWillUnmount() {
    document.removeEventListener("saveProbation", this.saveProbationFunction);
  }

  render() {
    const { starts_at, ends_at, notes } = this.props.probation;

    return (
      <Modal show={this.props.show} onHide={this.handleClose.bind(this)}>
        {!this.props.isStaffApp && (
          <Modal.Header closeButton>
            <Modal.Title>Probation</Modal.Title>
          </Modal.Header>
        )}
        <Modal.Body>
          {this.props.hasEdit ? (
            <>
              <Row>
                <Col sm={6}>
                  <Form.Group controlId="probationStartedAt">
                    <Form.Label>Started At</Form.Label>
                    <DatePicker
                      className="form-control"
                      selected={starts_at ? moment(starts_at) : null}
                      onChange={(date) => {
                        this.handleChange(
                          "starts_at",
                          moment(date).format("YYYY-MM-DD")
                        )
                      }} />
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <Form.Group controlId="probationEndedAt">
                    <Form.Label>Ended At</Form.Label>
                    <DatePicker
                      className="form-control"
                      selected={ends_at ? moment(ends_at) : null}
                      onChange={(date) => {
                        this.handleChange(
                          "ends_at",
                          moment(date).format("YYYY-MM-DD")
                        )
                      }} />
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group controlId="probationNotes">
                <Form.Label>Notes</Form.Label>
                <Form.Control
                  as="textarea"
                  value={notes}
                  onChange={(e) => {
                    this.handleChange("notes", e.target.value)
                  }} />
              </Form.Group>
            </>
          ) : (
            <>
              <Row>
                <Col sm={6}>
                  <Form.Group>
                    <Form.Label>Started At</Form.Label>
                    <div className="form-control-plaintext">{starts_at ? moment(starts_at).format('MM/DD/YYYY') : 'N/A'}</div>
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <Form.Group>
                    <Form.Label>Ended At</Form.Label>
                    <div className="form-control-plaintext">{ends_at ? moment(ends_at).format('MM/DD/YYYY') : 'N/A'}</div>
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group>
                <Form.Label>Notes</Form.Label>
                <div className="form-control-plaintext">{notes || 'N/A'}</div>
              </Form.Group>
            </>
          )}
        </Modal.Body>
        {!this.props.isStaffApp ? (
          <Modal.Footer>
            {
              this.props.action === "edit" && this.props.hasDelete &&
              <Button
                variant="outline-danger"
                onClick={() => this.deleteProbation()}>
                Delete
              </Button>
            }
            <Button
              variant="info"
              onClick={() => this.saveProbation()}>
              {this.props.action === "edit" ? "Update" : "Create"}
            </Button>
          </Modal.Footer>
        ) : (
          <div className="p-4">
            {this.props.action == "edit" &&  this.props.hasDelete && (
              <Button
                onClick={() => this.deleteProbation()}
                variant="outline-danger"
                className="w-100"
              >
                Delete
              </Button>
            )}
          </div>
        )}

      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    show: state.ui.probationModal.show,
    probation: state.ui.probationModal.probation,
    action: state.ui.probationModal.action,
    organizationName: state.organization.name,
    resident: state.resident,
    isStaffApp: state.config.isStaffApp,
    probationTabDefaultMetaData: state.config.tab_default_meta_data.find(
      (tab) => tab.detail == "probations"
    ),
    hasDelete: state.current_user.permissions.includes('Delete'),
    hasEdit: state.current_user.permissions.includes('Edit'),
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => {
      dispatch({
        type: "CLOSE_RESOURCE_MODAL",
        payload: { resourceName: "probation" }
      });
    },
    updateField: (name, value) => {
      dispatch({
        type: "UPDATE_RESOURCE_FIELD",
        payload: { resourceName: "probation", name, value }
      });
    },
    updateProbations: (probations) => {
      dispatch({
        type: "UPDATE_PROBATIONS",
        payload: { probations }
      });
    },
    createProbation: (probation) => {
      dispatch({
        type: "CREATE_PROBATION",
        payload: { probation }
      });
    },
    deleteProbation: (probation) => {
      dispatch({
        type: "DELETE_PROBATION",
        payload: { probation }
      })
    }
  };
}

export default withFetchHook(connect(mapStateToProps, mapDispatchToProps)(ProbationFormModal));
